import {
  B2BColorConfig,
  defaultCorpColors,
  defaultWithXmodColors,
} from "redmond";

export const colors: B2BColorConfig = defaultCorpColors;
export const xmodColorVars = defaultWithXmodColors;
